export default class messageDelaySettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/automation/directives/message-delay-settings.html'),
            scope: {
                automation: '=',
                message: '=',
                customDateFields: '=',
                trigger: '='
            },
            controller: [
                '$scope', '$element', '$attrs', '$filter', '$q', 'Automation', 'Events', 'Segment', 'TimePrinter',
                (scope, element, attr, $filter, $q, Automation, Events, Segment, TimePrinter) => {

                var withProgress = false;
                var hidden = true;
                var shouldSyncFilter = false;

                $(document).keyup((e) => {
                    if (e.keyCode == 27) { // Close modal on escape.
                        scope.message['showSettings'] = false;
                        scope.$apply();
                    }
                });

                scope.timeUnits = [
                    { value: 1, name: $filter('translate')('TIME:SECONDS'), key: 'seconds'},
                    { value: 60, name: $filter('translate')('TIME:MINUTES'), key: 'minutes'},
                    { value: 3600, name: $filter('translate')('TIME:HOURS'), key: 'hours'},
                    { value: 86400, name: $filter('translate')('TIME:DAYS'), key: 'days'}
                ];

                scope.operators = [
                    { value: 'is_days', key: 'after', text: $filter('translate')('SEGMENTATION:SELECTION:IS_DAYS') },
                    { value: 'is_days_recurring', key: 'after', text: $filter('translate')('SEGMENTATION:SELECTION:IS_DAYS_RECURRING') },
                    { value: 'is_days_before', key: 'before', text: $filter('translate')('SEGMENTATION:SELECTION:DAYS_BEFORE') },
                    { value: 'is_days_before_recurring', key: 'before', text: $filter('translate')('SEGMENTATION:SELECTION:DAYS_BEFORE_RECURRING') }
                ];

                scope.settings = {
                    timeUnit: scope.timeUnits[2],
                    numUnits: 0,
                    operator: scope.operators[0],
                    dateValue: 0,
                    recurring: false
                };

                scope.$watch('customDateFields', (newVal, oldVal) => {
                    if (newVal && ! scope.settings.customTrigger) {
                        scope.settings['customTrigger'] = scope.customDateFields[0].id;
                    }
                });

                scope.$watch('settings.customTrigger', (newVal) => {
                    angular.forEach(scope.customDateFields, (dateField) => {
                        if (dateField.id == newVal) {
                            scope.customTriggerName = dateField.name;
                        }
                    })
                });

                scope.closeModal = () => {
                    scope.message['showSettings'] = false;
                };

                var setupSpecialTriggerSettings = (segment) => {
                    var syncAt = moment(segment.sync_at, 'HH:mm:ss');
                    var segmentSettings = angular.fromJson(segment.structure)['rules']['groups']['rules'][0];

                    scope.settings['syncAt'] = { hour: syncAt.get('hours'), minutes: syncAt.get('minutes') };
                    scope.settings['customTrigger'] = segmentSettings.field;
                    scope.settings['operator'] = segmentSettings.operator;

                    angular.forEach(scope.operators, (operator) => {
                        if (operator.value == segmentSettings.operator) {
                            scope.settings['operator'] = operator;
                            scope.settings['dateValue'] = segmentSettings.value;
                        }
                    });
                };

                var setupStandardTriggerSettings = () => {
                    var delay = TimePrinter.getTimeUnitAndCount(scope.message.delay_in_seconds, 'seconds');

                    angular.forEach(scope.timeUnits, (unit) => {
                        if (unit.key == delay.unit) {
                            scope.settings['timeUnit'] = unit;
                            scope.settings['numUnits'] = delay.numUnits;
                        }
                    });
                };

                scope.$watch('message', (newVal, oldVal) => {
                    if (newVal) {
                        if (! scope.message.standardTrigger) {
                            Segment.find(scope.message.segment_id).then((segment) => {
                                segment = segment.data;
                                segment.tags = segment.tags.data;
                                scope.customSegment = segment;

                                if (scope.isCombined(segment)) { // Fetch the date part..
                                    getDateSegmentFromCombined(null, true).then(() => {
                                        scope.dateSegment.sync_at = segment.sync_at;
                                        setupSpecialTriggerSettings(scope.dateSegment);
                                    });
                                } else {
                                    setupSpecialTriggerSettings(segment);
                                }
                            });
                        } else {
                            setupStandardTriggerSettings();
                        }
                    }
                });

                var createCombinedSegment = (newSegment) => {

                    var combinedSegmentName = "CombinedCustomTrigger" + scope.message.id;
                    Segment.store(combinedSegmentName, '', newSegment.tags).then((response) => {
                        var combinedSegment = response.data;
                        combinedSegment.sync_at = {
                            hour: scope.settings.syncAt.hour,
                            minutes: scope.settings.syncAt.minutes
                        };
                        combinedSegment.tags = newSegment.tags;
                        combinedSegment.newCombined = true;
                        combinedSegment.structure = {
                            rules: {
                                groups: {
                                    key: 'and',
                                    segments: [scope.automation.trigger.id, newSegment.id]
                                }
                            }
                        };

                        var createCombinedSegment = false;
                        var setTrigger = true;
                        updateCustomSegment(combinedSegment, createCombinedSegment, setTrigger);
                    });
                };

                scope.isCombined = (segment) => {
                    try {
                        var structure = angular.fromJson(segment.structure);

                        return structure.rules.groups.segments.length > 0;
                    } catch (error) {
                        return false;
                    }
                };

                var getDateSegmentFromCombined = (tagIdsToAdd, initial) => {
                    var deferred = $q.defer();
                    var structure = angular.fromJson(scope.customSegment.structure);
                    var currentId;

                    try {
                        for (var i = 0; i < structure.rules.groups.segments.length; i++) {
                            currentId = structure.rules.groups.segments[i];

                            if (currentId != scope.customSegment.id && currentId != scope.automation.trigger.id) {
                                Segment.find(currentId).then((response) => {
                                    var segment = response.data;
                                    if (initial == true) {
                                        scope.dateSegment = segment;
                                        deferred.resolve();
                                    } else {
                                        scope.customSegment = segment;
                                        scope.customSegment.tags = tagIdsToAdd;
                                        deferred.resolve();
                                    }
                                });
                            }
                        }
                    } catch (error) {
                        deferred.reject();
                    }

                    return deferred.promise;
                };

                var setCustomTrigger = (segment) => {
                    Automation.setCustomMessageTrigger(
                        scope.automation.id,
                        scope.message.id,
                        scope.message.message_type_id,
                        segment.id
                    );
                };

                var updateCustomSegment = (segment, createCombined, updateCustomTrigger) => {
                    if (! segment.newCombined) {
                        segment.structure = { rules: { groups: { key: 'or', groups: [], rules: [{
                            field: scope.settings.customTrigger,
                            operator: scope.settings.operator.value,
                            value: scope.settings.dateValue
                        }]}}};
                    }

                    if (scope.automation.trigger.type != 'segment' || segment.newCombined) {
                        segment.sync_at = { hour: scope.settings.syncAt.hour, minutes: scope.settings.syncAt.minutes };
                    } else {
                        segment.sync_at = null;
                    }

                    Segment.update(segment, withProgress, hidden, shouldSyncFilter).then(() => {
                        if (createCombined == true) {
                            createCombinedSegment(segment);
                        } else if (updateCustomTrigger == true) {
                            setCustomTrigger(segment);
                            scope.message['delay_in_seconds'] = 0;
                            scope.message['standardTrigger'] = false;
                            scope.message['segment_id'] = segment.id;
                        }

                        if (scope.message.message_type_id == 1) {
                            Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:EMAIL_UPDATED'));
                        } else {
                            Events.flashEvent('notification', $filter('translate')('AUTOMATION:FLASH:TEXT_UPDATED'));
                        }
                        scope.closeModal();
                    });
                };

                var storeCustomSegment = (tagIds) => {
                    var segmentName = scope.automation.name + " custom trigger" + Date.now() + ' ' + scope.message.id;
                    var createCombinedSegment = scope.automation.trigger.type == 'segment';
                    var setTrigger = ! createCombinedSegment;

                    Segment.store(segmentName, '', tagIds).then((response) => {
                        response.data.tags = tagIds;

                        updateCustomSegment(response.data, createCombinedSegment, setTrigger);
                    });
                };

                var validCustomTrigger = () => {
                    return  scope.settings.syncAt.minutes != null &&
                        scope.settings.syncAt.minutes >= 0 &&
                        scope.settings.syncAt.hour != null &&
                        scope.settings.syncAt.hour >= 0 &&
                        scope.settings.dateValue != null &&
                        scope.settings.dateValue >= 0;
                };

                var updateSyncAtForCombined = (combinedSegment, tags) => {
                    combinedSegment.tags = tags;
                    combinedSegment.sync_at = {
                        hour: scope.settings.syncAt.hour,
                        minutes: scope.settings.syncAt.minutes
                    };

                    Segment.update(combinedSegment, withProgress, hidden, shouldSyncFilter);
                };

                scope.saveSettings = () => {
                    if (scope.message.standardTrigger) {
                        var delayInSeconds = scope.settings.numUnits * scope.settings.timeUnit.value;

                        if (delayInSeconds < 0) {
                            return Events.flashEvent('error', $filter('translate')('AUTOMATION:FLASH:NEGATIVE_DELAY'));
                        }

                        Automation.setMessageDelay(
                            scope.automation.id,
                            scope.message.id,
                            delayInSeconds,
                            scope.message.message_type_id
                        ).then((response) => {
                            scope.message['standardTrigger'] = true;
                            scope.message['segment_id'] = null;
                            scope.message['delay_in_seconds'] = response.delay_in_seconds;
                            scope.closeModal();
                        });
                    } else {
                        if (validCustomTrigger()) {
                            var setTrigger = false;
                            var createCombinedSegment = false;

                            if (scope.automation.trigger.type == 'segment') {
                                Segment.find(scope.automation.trigger.id).then((response) => {
                                    var tagIds = _.map(response.data.tags.data, (tag) => {
                                        return tag.id;
                                    });

                                    if (scope.isCombined(scope.customSegment)) {
                                        // Already a combined segment, update date part.
                                        updateSyncAtForCombined(scope.customSegment, tagIds);
                                        getDateSegmentFromCombined(tagIds).then(() => {
                                            updateCustomSegment(scope.customSegment, createCombinedSegment, setTrigger);
                                        });
                                    } else {
                                        // Create a new combined segment.
                                        storeCustomSegment(tagIds);
                                    }
                                });
                            } else {
                                if (scope.message.segment_id == null) {
                                    storeCustomSegment([scope.automation.trigger.id]);
                                } else {
                                    scope.customSegment.tags = [scope.automation.trigger.id];
                                    setTrigger = true;
                                    updateCustomSegment(scope.customSegment, createCombinedSegment, setTrigger);
                                }
                            }
                        } else {
                            Events.flashEvent('error', $filter('translate')('AUTOMATION:FLASH:INVALID_TRIGGER_SEGMENT'));
                        }
                    }
                };
            }]
        }
    }
}
